import React from "react";
import "../styles/AboutPage.css";
import aboutImage from "../assets/about-image.jpg";
import missionImage from "../assets/mission.jpeg";
import visionImage from "../assets/vision.jpeg";
import diagramImg from "../assets/ADAM BOARD NAMES.png";

import { boardMembers, teamMembers, Executivemanagers } from "../data/teamData";
import Timeline from "../components/Timeline";

const AboutPage = () => {
  const values = [
    {
      icon: "🚀",
      title: "Customer-Centric",
      description: "Understanding and exceeding client expectations."
    },
    {
      icon: "🤝",
      title: "Excellence",
      description: "Maintaining high standards in every project and service."
    },
    {
      icon: "💡",
      title: "Innovation",
      description: "Continuously evolving through creative and technological advancements."
    },
    {
      icon: "⚖️",
      title: "Integrity",
      description: "Operating with honesty, transparency, and responsibility."
    },
    {
      icon: "🌱",
      title: "Sustainability",
      description: "Driving projects that create long-term positive impacts on communities and the environment."
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <header className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About Us</h1>
          <p className="about-hero-subtitle">
            Meet ADAM Holding: The leading platform driving the global business world into the future.
          </p>
        </div>
      </header>

      {/* Who We Are Section */}
      <section className="about-section about-who-we-are">
        <div className="about-section-container">
          <div className="about-image-container">
            <img src={aboutImage} alt="About Adam Holding Union" className="about-image" />
          </div>
          <div className="about-content-container">
            <h2 className="about-section-title">Who We Are</h2>
            <div className="about-text">
              <p>
                ADAM Holding Union is a leading EPCM (Engineering, Procurement, Construction, and Management) 
                enterprise recognized for its comprehensive and integrated project solutions. Founded in 1991, 
                the company has established itself as a trusted partner in sectors ranging from infrastructure 
                and industrial development to consultancy and education.
              </p>
              <p>
                With headquarters strategically located in the United States, Europe, the Gulf region, and Africa, 
                ADAM Holding Union operates as a hub for innovation, expertise, and technological advancement.
              </p>
              <p>
                Our mission is to provide world-class solutions to both public and private sectors, addressing 
                complex challenges with a focus on delivering high-quality services within budget and on time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Sections */}
      <div className="about-mission-vision-grid">
        <section className="about-section about-mission">
          <div className="about-mission-content">
            <div className="about-mission-image">
              <img src={missionImage} alt="Our Mission" />
            </div>
            <div className="about-mission-text">
              <h2 className="about-section-title">Our Mission</h2>
              <p>
                ADAM is committed to setting new standards of excellence in its professional career and in every 
                aspect of its business activities. We ensure the highest levels of client satisfaction by offering 
                high-quality services on time and within budget, using the best technology resources and materials available.
              </p>
              <p>
                We believe in professionalism with responsibility, delivering the highest quality services to our 
                clients while contributing to the development of companies, countries, and our society as a whole.
              </p>
            </div>
          </div>
        </section>

        <section className="about-section about-vision">
          <div className="about-vision-content">
            <div className="about-vision-image">
              <img src={visionImage} alt="Our Vision" />
            </div>
            <div className="about-vision-text">
              <h2 className="about-section-title">Our Vision</h2>
              <p>
                Adam's vision is to transform and enhance lifestyles by driving business evolution and development. 
                As a leading Business Center and Expertise House, we strive for excellence, international standards, 
                and efficiency to foster urbanization and growth.
              </p>
              <p>
                We aim to be the preferred partner for sustainable development, creating lasting value for all 
                stakeholders while pushing the boundaries of innovation and excellence in every project we undertake.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Timeline Section */}
      <section className="about-section about-timeline">
        <h2 className="about-section-title">Our Journey</h2>
        <p className="about-section-subtitle">
          A timeline of our growth and achievements since our foundation in 1991.
        </p>
        <Timeline />
      </section>

      {/* Board of Directors Section */}
      <section className="about-section about-board">
        <h2 className="about-section-title">Board of Directors</h2>
        <p className="about-section-subtitle">
          Meet the leadership team guiding ADAM Holding Union towards continued success.
        </p>
        
        {/* Diagram Container - Geliştirilmiş */}
        <div className="about-diagram-container">
          <div className="about-diagram-wrapper">
            <img src={diagramImg} alt="Adam Holding Board Structure" className="about-diagram-image" />
          </div>
        </div>

        <div className="about-team-sections">
          {/* ADAM BOARD (Üst Yönetim) */}
          <div className="about-team-section">
            <div className="about-team-section-header">
              <h3 className="about-team-section-title">Founding Body</h3>
              <span className="about-team-section-count">{boardMembers.length} Members</span>
            </div>
            <div className="about-team-grid about-team-grid--founding">
              {boardMembers.map((member, index) => (
                <div className="about-team-card" key={index}>
                  <div className="about-team-card-image-wrapper">
                    <div className="about-team-card-image">
                      <img src={member.photo} alt={member.name} />
                    </div>
                  </div>
                  <div className="about-team-card-content">
                    <span className="about-team-card-title-prefix">{member.title}</span>
                    <h4 className="about-team-card-name">{member.name}</h4>
                    <p className="about-team-card-role">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Direktörler */}
          <div className="about-team-section">
            <div className="about-team-section-header">
              <h3 className="about-team-section-title">Board Members</h3>
              <span className="about-team-section-count">{teamMembers.length} Members</span>
            </div>
            <div className="about-team-grid about-team-grid--board">
              {teamMembers.map((member, index) => (
                <div className="about-team-card" key={index}>
                  <div className="about-team-card-image-wrapper">
                    <div className="about-team-card-image">
                      <img src={member.photo} alt={member.name} />
                    </div>
                  </div>
                  <div className="about-team-card-content">
                    <span className="about-team-card-title-prefix">{member.title}</span>
                    <h4 className="about-team-card-name">{member.name}</h4>
                    <p className="about-team-card-role">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CEO'lar */}
          <div className="about-team-section">
            <div className="about-team-section-header">
              <h3 className="about-team-section-title">Executive Managers (CEOs)</h3>
              <span className="about-team-section-count">{Executivemanagers.length} Members</span>
            </div>
            <div className="about-team-grid about-team-grid--executive">
              {Executivemanagers.map((member, index) => (
                <div className="about-team-card" key={index}>
                  <div className="about-team-card-image-wrapper">
                    <div className="about-team-card-image">
                      <img src={member.photo} alt={member.name} />
                    </div>
                  </div>
                  <div className="about-team-card-content">
                    <span className="about-team-card-title-prefix">{member.title}</span>
                    <h4 className="about-team-card-name">{member.name}</h4>
                    <p className="about-team-card-role">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-section about-values">
        <h2 className="about-section-title">Our Core Values</h2>
        <p className="about-section-subtitle">
          The principles that guide every decision and action at ADAM Holding Union.
        </p>
        <div className="about-values-grid">
          {values.map((value, index) => (
            <div className="about-value-card" key={index}>
              <div className="about-value-icon">{value.icon}</div>
              <h3 className="about-value-title">{value.title}</h3>
              <p className="about-value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-section about-cta">
        <div className="about-cta-content">
          <h2 className="about-cta-title">Partner with Excellence</h2>
          <p className="about-cta-text">
            Join us on our journey to shape a better future through innovation, integrity, and excellence.
          </p>
          <div className="about-cta-buttons">
            <a href="/contact" className="about-btn about-btn--primary">Get in Touch</a>
            <a href="/sectors" className="about-btn about-btn--secondary">Explore Our Sectors</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;